import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

const CreateLink = styled(Link)`
  display: flex;
  width: 97.69px;
`;

export default CreateLink;
